// --- Sustainability constants

export const SUSTAINABILITY_MAX = 10;
export const SUSTAINABILITY_MIN = 0;